import appData from './appData';

export default { appData };
